import { useActor } from '@ui-common/hooks/useActor'
import { useIntl } from 'react-intl'
import { AnyActorRef } from 'xstate'

import { SendView } from '../../../common/steps/send-step/SendView'
import { useIfpPageViewEvent } from '../../analytics/analyticsContext'
import { WizardStep } from '../../wizard/wizardMachine'
import { sendStepMachine } from './sendStepMachine'

interface SendStepProps {
  parentService: AnyActorRef
  onAbort: () => unknown
  applicationId: string
  authCode: string
}

const SendStep = ({ applicationId, parentService, authCode, onAbort }: SendStepProps) => {
  const intl = useIntl()
  useActor(sendStepMachine(parentService), { input: { applicationId, authCode } })

  useIfpPageViewEvent(WizardStep.SendStep)

  return (
    <SendView
      sendingHeader={intl.formatMessage({ id: 'common-applications-under-processing' })}
      delayedSendingHeader={intl.formatMessage({ id: 'common-applications-hold-on' })}
      sendingDescription={intl.formatMessage({ id: 'common-wait-description' })}
      delayedSendingDescription={intl.formatMessage({ id: 'ifp-application-send-step-application-received-text' })}
      onAbort={onAbort}
    />
  )
}

export default SendStep
